export const SortByOptions = {
  LATEST: {
    key: 'LATEST',
    text: 'Latest',
  },
  ALPHABETICAL: {
    key: 'ALPHABETICAL',
    text: 'Alphabetical',
  },
  DURATION_ASC: {
    key: 'DURATION_ASC',
    text: 'Duration (Ascending)',
  },
  DURATION_DESC: {
    key: 'DURATION_DESC',
    text: 'Duration (Descending)',
  },
  CREDIT_ASC: {
    key: 'CREDIT_ASC',
    text: 'Credit (Ascending)',
  },
  CREDIT_DESC: {
    key: 'CREDIT_DESC',
    text: 'Credit (Descending)',
  },
} as const;

type MapKeys = Array<keyof typeof SortByOptions>;

const SORT_BY_NON_NASBA: MapKeys = [
  'LATEST',
  'ALPHABETICAL',
  'DURATION_ASC',
  'DURATION_DESC',
];
const SORT_BY_NASBA: MapKeys = [
  'LATEST',
  'ALPHABETICAL',
  'CREDIT_ASC',
  'CREDIT_DESC',
  'DURATION_ASC',
  'DURATION_DESC',
];

const getSortByOptions = (keys: MapKeys) =>
  keys.reduce((acc, key) => ({ ...acc, [key]: SortByOptions[key] }), {});

export const SortByOptionsNonNasba = getSortByOptions(SORT_BY_NON_NASBA);
export const SortByOptionsNasba = getSortByOptions(SORT_BY_NASBA);

export const AllOption = {
  key: 'ALL',
  text: 'All',
};

export const EpisodeFilterDefaults = {
  sortBy: SortByOptions.LATEST.key,
  onlyEthics: false,
  hidePlayed: false,
  selectedFos: [],
  selectedCategories: [],
  format: AllOption.key,
  region: AllOption.key,
  mediaType: AllOption.key,
  audienceFunction: AllOption.key,
};

export const LibraryUrlSearchParams = {
  AUDIENCE_FUNCTION: 'audienceFunction',
  CATEGORY_SLUG: 'category',
  SUB_CATEGORY_SLUG: 'subCategory',
  FORMAT: 'format',
  MEDIA_TYPE: 'mediaType',
  FUNCTION: 'audienceFunction',
  SORT_BY: 'sortBy',
} as const;
